export default "/images/vendor/@coreui/icons/svg/flag/cif-cd.svg?8c90b452d7bec31dfc8a6a4bb19c42b9";